import * as yup from "yup";

import { parseSourceUrls } from "../urlMappingFormUtils";

import { UrlMappingFormValues } from "./UrlMappingForm";

const isValidJsRegex = (pattern: string): boolean => {
  try {
    // Frontend can only validate JS RegExp syntax. Ruby may still reject edge cases.
    // eslint-disable-next-line no-new
    new RegExp(pattern);
    return true;
  } catch {
    return false;
  }
};

export const validationSchema = yup.object({
  name: yup.string().nullable(),
  active: yup.boolean().required(),
  matchType: yup.string().required("マッチ種別を選択してください"),
  priority: yup
    .number()
    .typeError("優先度は数値で入力してください")
    .integer("優先度は整数で入力してください")
    .required("優先度を入力してください"),
  sourceUrls: yup.string().when("matchType", {
    is: "EXACT",
    then: (schema) =>
      schema.test(
        "has-source-urls",
        "ソースURLを1行以上入力してください",
        (value) => parseSourceUrls(value || "").length > 0
      ),
    otherwise: (schema) => schema.nullable(),
  }),
  sourceUrl: yup.string().when("matchType", {
    is: "PREFIX",
    then: (schema) => schema.required("ソースURLを入力してください"),
    otherwise: (schema) => schema.nullable(),
  }),
  sourceHost: yup.string().when("matchType", {
    is: "HOST_PATH",
    then: (schema) => schema.required("ソースホストを入力してください"),
    otherwise: (schema) => schema.nullable(),
  }),
  sourcePath: yup.string().when("matchType", {
    is: "HOST_PATH",
    then: (schema) => schema.required("ソースパスを入力してください"),
    otherwise: (schema) => schema.nullable(),
  }),
  regexPattern: yup.string().when("matchType", {
    is: "REGEX",
    then: (schema) =>
      schema
        .required("正規表現を入力してください")
        .test(
          "valid-regex",
          "正規表現の構文が不正です",
          (value) => !value || isValidJsRegex(value)
        ),
    otherwise: (schema) => schema.nullable(),
  }),
  destinationUrl: yup.string().required("宛先URLを入力してください"),
  destinationMode: yup.string().required(),
  conditionRows: yup.array().of(
    yup.object({
      kind: yup.string().required(),
      matchMode: yup.string().required(),
      key: yup.string().when("kind", {
        is: "query_param",
        then: (schema) =>
          schema.trim().required("クエリパラメータのキーを入力してください"),
        otherwise: (schema) => schema.nullable(),
      }),
      value: yup
        .string()
        .trim()
        .required("条件の値を入力してください")
        .test(
          "valid-condition-regex",
          "正規表現の構文が不正です",
          function (value) {
            if (this.parent.matchMode !== "regex") return true;
            return !value || isValidJsRegex(value);
          }
        ),
    })
  ),
  startsAt: yup.date().nullable().typeError("無効な日付です"),
  endsAt: yup
    .date()
    .nullable()
    .typeError("無効な日付です")
    .test(
      "ends-after-starts",
      "終了日時は開始日時より後に設定してください",
      function (endsAt) {
        const startsAt = this.parent.startsAt as Date | null | undefined;
        if (!startsAt || !endsAt) return true;
        return endsAt.getTime() > startsAt.getTime();
      }
    ),
}) as yup.SchemaOf<UrlMappingFormValues>;
